import React from "react";
import { IconButton, useTheme } from "@mui/material";

export const useDotButton = (emblaApi) => {
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [scrollSnaps, setScrollSnaps] = React.useState([]);

  const onDotButtonClick = React.useCallback(
    (index) => {
      if (emblaApi) emblaApi.scrollTo(index);
    },
    [emblaApi]
  );

  const onInit = React.useCallback((api) => {
    setScrollSnaps(api.scrollSnapList());
  }, []);

  const onSelect = React.useCallback((api) => {
    setSelectedIndex(api.selectedScrollSnap());
  }, []);

  React.useEffect(() => {
    if (!emblaApi) return;
    onInit(emblaApi);
    onSelect(emblaApi);
    emblaApi.on("reInit", onInit).on("reInit", onSelect).on("select", onSelect);
  }, [emblaApi, onInit, onSelect]);

  return { selectedIndex, scrollSnaps, onDotButtonClick };
};

// ✅ Versión final con diseño MUI y compatibilidad con className
export const DotButton = ({ className, onClick }) => {
  const theme = useTheme();

  return (
    <IconButton
      onClick={onClick}
      className={className}
      sx={{
        width: "24px",
        height: "24px",
        borderRadius: "50%",
        border: `2px solid ${theme.palette.secondary.main}`,
        backgroundColor: "transparent",
        transition: "all 0.3s ease",
        "&.embla__dot--selected": {
          backgroundColor: theme.palette.secondary.main,
        },
        "&:hover": {
          backgroundColor: theme.palette.secondary.main,
        },
      }}
    />
  );
};
